<template>
  <div class="page__back" @click="onBack">
    <div class="page__back-icon">
      <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 5.5H2M2 5.5L6.14815 1M2 5.5L6.14815 10" stroke="#95A4C0" stroke-width="1.5"/>
      </svg>
    </div>
    Назад
  </div>
</template>

<script>
import { prevPage } from '@/utils/router'

export default {
  props: {
    onBack: {
      type: Function,
      required: false,
      default: prevPage
    }
  }
}
</script>
